import { useContext, useEffect } from "react";
import { NotificationContext } from "../../contexts/notificationContext";
import { CloseOutlined } from "@ant-design/icons";
import { Drawer, List } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import notificationAPI from "../../services/api/notificationAPI";
import './notification.css';
import useNotificationStore from "../../hooks/useNotificationStore";

const NotificationBell = () => {
    const { notifications, refreshNotifications } = useContext(NotificationContext);
    const { isDrawerOpen, toggleDrawer, setDrawerOpen, hasInitialized } = useNotificationStore();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!hasInitialized) {
            setDrawerOpen(false);
        }
        refreshNotifications();
    }, []);

    const handleNotificationClick = async (index) => {
        const selectedNotification = notifications[index];
        const response = await notificationAPI.UpdateNotification(selectedNotification.notificationId);

        if (response.status) {
            await refreshNotifications(); //  Fetch latest notifications after updating
            setDrawerOpen(false);
            if (selectedNotification?.orderId) {
                navigate(`/invoice-detail?invoiceId=${selectedNotification.orderId}`, { state: { previousPath: location.pathname } });
            }
        }
    };

    return (
        <>
            <div className="circle me-3" onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleDrawer();
            }}>
                <div className="sub-circle position-absolute">
                    {notifications.filter(n => !n.seen).length}
                </div>
                <i className="fa-solid fa-bell bell-icon pointer"></i>
            </div>

            <Drawer
                title="Notifications"
                placement="right"
                closable={true}
                onClose={() => setDrawerOpen(false)}
                open={isDrawerOpen}
                width={400}
                closeIcon={<CloseOutlined />}
                maskClosable={false}
                destroyOnClose={true}
            >
                <List
                    dataSource={notifications}
                    renderItem={(item, index) => (
                        <List.Item
                            onClick={() => handleNotificationClick(index)}
                            style={{
                                cursor: "pointer",
                                padding: "4px 10px 2px 10px",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px", // Space between icon and message
                                }}
                                className="notification"
                            >
                                <i className="fa-solid fa-box not-icon"
                                    style={{
                                        width: "31px",
                                    }}></i>
                                {item.message}
                            </span>
                        </List.Item>
                    )}
                />
            </Drawer>
        </>
    );
};

export default NotificationBell;
